import AttendancePage from '../../components/attendancePage';

const DirectorAttendance = () => (
  <AttendancePage userType="director" title="Director Attendance" />
);

export default DirectorAttendance;
